import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface AgentUserGlobalTemplateToggleStatusResponse {
  message: string;
  id: number;
  status?: number;
}

export class ToggleAgentUserStatusData {
  @IsNumber("status must be a number")
  status?: number;
}

const transformAndValidateData = (
  response: AgentUserGlobalTemplateToggleStatusResponse
): ToggleAgentUserStatusData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ToggleAgentUserStatusData);
  } catch (error) {
    console.error("AgentUserGlobalTemplateToggleStatus data validation failed:", error.message);
    throw error;
  }
};

// 企业模板启用/禁用
export const toggleAgentUserGlobalTemplateStatus = async ({ id }: { id: number }) => {
  const res = await api.post<AgentUserGlobalTemplateToggleStatusResponse>('/agent/user-global-template/toggle-status', {
    id,
  });
  return transformAndValidateData(res.data);
};
